import { api } from '../api';

const AUTHORIZATION_VALUE_PREFIX = 'mfasession';

interface MultiFactorAuthenticationRequestRequest {
  id: string;
}

const request = async (id: string, { authToken }: { authToken: string }) =>
  api.post<void>(
    '/multiFactorAuthentication.request',
    { id },
    {
      Authorization: `${AUTHORIZATION_VALUE_PREFIX} ${authToken}`,
    },
  );

export default request;
